module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "c1"
    }
  }), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UN AND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROLIC")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p01-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Grief can take care of itself, but to get the full value of joy you must have somebody to divide it with.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Friends are the folks we "), _c('i', [_vm._v("play")]), _vm._v(" with, as kids and as adults. Our adventures together give life its zest, even if we are doing nothing more than sitting around together sharing a meal or a movie. And watch out when we really get going!")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-1"
    }
  }), _vm._v("Shop'til We Drop")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("What is it about shopping that cements a friendship between women? Perhaps it's the shared time browsing together, enjoying the splash of colors, fingering the smooth silk or the nubby tweed, while the scents of perfume from the exotic to the floral drift through the stores. Maybe it's the idea of the quest, the search for the perfect black dress or the pursuit of a bargain, with the malls and stores becoming giant treasure chests filled with wonderful and exotic discoveries.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p04-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("As a teenager, I'd hit the mall with my friends. We were a giggling pack of self-conscious hormones. We tried on dresses, then outrageous, floppy hats that we'd never buy, always keeping an eye out for any cute boys.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Now I'm a mom. I park my stroller at the mall playground and catch up with my friends in between shopping forays. We compare childhood developmental notes, trade discipline strategies, and laugh over silly things our kids say, while the mall fountain ripples in the background.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("More than anything, I think we shop together because it mirrors our relationships. Men play golf; they compete. Women stroll between crowded racks and weave in and out among display cases, with conversations meandering with their steps. Our casual "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("chitchat can dip unexpectedly into private pain and confidences over a rack of shirts or in front of the three-way dr essing room mirror. Our conversations crisscross, our paths wind through unexpected turns, while our lives intertwine in deeper friendship.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Sara E. Rosett")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And in the sweetness of friendship let there be laughter, and sharing of pleasures. For in the dew of little things the heart finds its morning and is refreshed.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHLIL")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBRAN")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-2"
    }
  }), _vm._v("Personalized Wrapping Paper")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("After you've shopped your heart out for a gift for a friend, consider adding a special touch with your very own wrapping paper. Or give the paper itself as a gift. You'll need solid color wrapping paper, small cookie cutters, and heavy-body acrylic paint (available at art supply stores). Lay out the wrapping paper. Dip the cutting edge of the cookie cutter into the paint and stamp onto the paper, beginning at the top left-hand corner. Thin the paint with water if it's too lumpy. Continue until "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("you've covered all the paper. Shapes can line up or overlap, depending on the design you've chosen. Allow to dry thoroughly before using.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-3"
    }
  }), _vm._v("You've Got Mail")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("When I was younger, I thought friendship meant constantly being together, doing each other's hair and nails, and talking about boys on the phone. I'm twenty-five now and have moved around a lot in the past years because of my job. As a result, deep and lasting relationships have been scarce. Thanks to the modern technology of e-mail, however, I have friendships all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("My friend in Germany sends me recipes she thinks even I would be able to follow. My friend in Brazil can find anything about anyone on the net, which comes in handy when I'm looking for the latest news on my favorite French actor. An artist buddy scans all her work and mails it to me before putting it forward to the various galleries, so that I can have my say—which is always good, of course. If I lived in New York, I would be the first in line to her show, to say so.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I reply with news about my day, about the comings and goings of life in South Africa, and the status of my seemingly never-to-be-finished novel, which I don't have time for. I scour the Sunday papers for interesting tidbits of information that any of them "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("might find remotely useful.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Thanks to that little voice crying, “You have mail,” I live in a city with millions of people that I don't know, yet I never feel lonely. There's one other advantage. No matter how many times you move, one address remains the same. Your e-mail address.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Liana van Niekerk")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The world is so empty if one thinks only of mountains, rivers and cities; but to know someone who thinks and feels with us, and who, though distant is close to us in spirit, this makes the earth for us an inhabited garden.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OETHE")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-4"
    }
  }), _vm._v("The Girls on the Second Floor")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Everyone in the apartment complex knew us, the girls on the second floor, by the sounds of rolling luggage at all hours of the day and night, by the slamming of trunks and car doors echoing off the buildings, by a car starting and then speeding off toward the Baltimore / Washington International Airport.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The four of us were in our twenties, just starting out as flight attendants. We all had pagers on our hips and an ear out for the phone. Bored and restless, we would wait for scheduling to call, passing books from one to another to help the reserve days go by quickly. Scary movies were another favorite pastime. We would sit on our futon couch, scrunched up together in the dark, eating popcorn. At some point one of us would always scream, causing a chain reaction. But we always ended up doubled over in laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("When one of us finally received “the call,” we would scurry around the two-bedroom apartment, throwing makeup, hairspray, and travel necessities in the chosen one's suitcase. She'd put her uniform on, touch up her makeup, and pin on her wings. With a final look in the mirror, she would be out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Whoever was left behind was responsible for making sure the Friday night parties happened. The music started out soft, with just a few friends present. As the evening progressed, however, the music grew louder and the apartment teemed with people. Finally a broomstick would pound on our living-room floor from "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("the apartment below, which led to a formal apology the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("On weekend mornings, we received a wakeup call from Navy planes flying over our apartment. The planes appeared so close that it seemed as if we could touch them if we stood on a ladder. We would climb out of bed, drink our coffee, and talk about the night before. Eventually, we would get ready for the day. By late afternoon we were found wandering the brick str eets of Annapolis, admiring the old homes that graced the historical area. We attended Navy football games when it was a home game, and made our presence known at the local pubs later on.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p09-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("On mellow evenings, we would gather with a bottle of white zinfandel and chat on our apartment balcony, Tracy Chapman's song “The Promise” playing in the background. Sometimes we resolved an argument. Other times, we dreamed about our weddings, having babies, whether or not the guys in our lives were “the one.” We talked about the rude passenger that yelled at us, or the man who passed out in our galley. Sometimes we shared a pack of cigarettes, at other times a box of Kleenex.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Now, years later, the idea of having roommates makes me cringe. Still, I treasure the memories of dancing in the living room and the pictures of us in downtown Annapolis. Every fall I search for a certain candle that smells like the candy corn we burned in those days. It never fails to bring me back to the living room in that second-floor apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Elizabeth L. Blair")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("A joy shared is a joy doubled.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OETHE")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Parmesan Popcorn")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You don't have to live together to have a movie night. Why not call a few friends, pick a theme (scary, romantic, top favorites), rent a few videos or DVDs, and try this popcorn recipe? It's much tastier than the packaged kind, and unbelievably easy to make. The flavored salt gives it even more of a distinctive flavor.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("2 teaspoons cooking oil")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup unpopped popcorn")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup melted butter")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("½ cup grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("salt, garlic salt, or celery salt, to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Put the oil and popcorn in a popcorn popper and pop until done. Combine remaining ingredients in a mixing cup and pour over popcorn. Stir well and serve. Makes 2 quarts.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-5"
    }
  }), _vm._v("Divine Intervention")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Our house had been on the market for six months, and there was still no buyer. What if we never sold it? The new house would be ready in eight weeks, and then what would we do? Two houses, two mortgages! It didn't bear thinking about.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Besides, I was fed up keeping the place so "), _c('i', [_vm._v("clean")]), _vm._v(". The flower arrangements insisted upon by the real estate agent made it look and smell more like a funeral parlor than a house. The scent of Lysol overlaid with chrysanthemum was a stench reminiscent of decay. I needed to kvetch, so I called Eileen. “I've got just the thing,” she said, after hearing of my dilemma. “I'll be right there.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I sighed. “She's probably bringing over another set of curtains,” I decided. She'd loaned me the ones in the spare bedroom—the previous set having been described by our agent as “a bit too sixtyish.” I wondered at the time whether possessing an attitude of disdain was a prerequisite for a job in real estate. In any event, I was sure it was going to take more than better curtains to sell this house.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Eileen was there in an hour, waving what looked like a white plastic toy in my face. “I could have given you lunch,” I said, slightly annoyed. I thought she'd gotten the toy free with burger and fries.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Look,” she said. “I've brought St. Joseph. We'll bury him in the backyard, and then your house will sell. Come on, where "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("do you want to put him? He has to be upside down or it won't work.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p12-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Had she lost her mind? I knew Eileen was religious, but this was ridiculous. My own grandmother had been institutionalized once with something called “religious mania.” Could my friend be going the same way? Should I humor her?")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Eileen,” I spluttered. “I don't think saints do things for Jews, do they?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“St. Joseph's flexible.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I just looked at her.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“It might not work,” she said. “But I've heard of people it has worked for.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“But you don't actually "), _c('i', [_vm._v("know")]), _vm._v(" any, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Well … no … but …” She giggled.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I began to giggle too.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Laughing, we went out back, dug a hole, and plunked the plastic figurine into it, upside down of course. I hoped the neighbors weren't watching.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I was still smiling as I said goodbye to Eileen. The sheer ridiculousness of the adventure had made me feel better. Eileen was the best kind of friend, and if St. Joseph had to be part of the deal, so be it. But it would take more than a statue to sell the house.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The house sold the following day.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Margaret Davidson")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("Celebrate the happiness that friends are always giving, make every day a holiday and celebrate just living!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MANDA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RADLEY")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-6"
    }
  }), _vm._v("Partners in Crime")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Fighting back tears, I watched one of my best friends walk down the aisle. While I was incredibly happy for Molly, memories of us goofing around when we were younger made me long for times past. That mor ning, her cousin had presented her with an album of pictures and stories of her premarriage life. We had all submitted something. As Molly neared the altar, I thought of my contribution to her album—a picture of the two of us at fourteen playing our French horns.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Molly and I met in junior high band. At the beginning of band, our conductor would tune the different instruments separately and then tune us all together. The French horn has a thumb key. When depressed, the thumb key can completely change any note you play. Molly and I thought it was funny to depr ess the thumb key when the whole band was tuning on the same note.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Our conductor, Mr. Timber, would make a little wrinkle in his forehead, trying to locate the source of the horr ibly out-of-tune sound. At first, he couldn't pinpoint that it was us, so he "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("would have to go back and tune each instrument separately, as we concealed our grins.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p14-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("As time went by, Mr. Timber caught on to our little game. One day, as we began giggling after an episode of tuning, he marched briskly toward us, pointed two fingers—one at each of us—and barked, “You two!” Then he proceeded to go into the next room, indicating that we were to follow him. We exchanged a scared look and went out after him.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("To this day, I have no idea what Mr. Timber said in those five minutes. I was just concentrating on not smiling. I knew that if I smiled I would make the situation worse. I also knew that if I gave Molly a sideways glance, it would set us into a fit of uncontrollable laughter. This was very difficult since we were also both trying to avoid Mr. Timber's bad breath. We were trying not to breathe, trying not to look at each other, and trying not to crack a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Now, at twenty-five, it is something we both still laugh about—and laughing together is the best thing to do with a friend. When you can laugh at yourself, you can handle anything. Realizing that, I knew Molly would find happiness in her new marriage and that we could always count on each other for a good laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Amanda Seim")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("A friend is another self.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISTOTLE")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-7"
    }
  }), _vm._v("Served with Love")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I opened my blue cookbook a few days ago to look for a recipe that a friend gave me. Where was that recipe for ice cream pie that my neighbor Kim made for my husband's birthday? She filled a crushed Oreo cookie crust with softened ice cream, then topped it with drizzled chocolate syrup. Oh, there it was, folded into my copy of "), _c('i', [_vm._v("Joy of Cooking")]), _vm._v(", along with a well-creased paper, an e-mail from a friend at work, with the recipe for her easy and wonderful Christmas fudge.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("That got me to thinking about all the food I've shared with friends: a creamy alfredo noodle dish from Bev, the chicken pasta salad another friend made for me when I was pregnant and my husband was out of town. I still make that pasta salad, and every time I toss the chicken, noodles, carrots, cucumbers, cheese, and dressing, I remember our relaxed conversation while I set her table and then perched on a chair while she pulled warm rolls from her oven. Food's pleasures are doubled when shared.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Sara E. Rosett")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("Friendships, like geraniums, bloom in kitchens.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LANCHE")]), _vm._v(" H. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELFANT")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-8"
    }
  }), _vm._v("Personalized Cookbooks")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It started out for me. I was struggling to figure out how to deal with all the recipes I clipped out of the food magazines I love so much. I ended up buying a blank book and pasting the recipes inside. I filled two huge books that way before I realized that it was not the most efficient way to collect such things: “Hmm, I'd like to make that braised raddiccio. It was somewhere on a left-hand page in the middle of the book with the blue cover….”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("So when my friend Diane asked me for the recipe for something she had eaten at my house, I decided to make her a personalized cookbook like mine—only better. This one would have sections—Appetizers, Soups, Entrees, Side Dishes, Desserts—and be in a three-ring binder so that she could add to it in the appropriate sections. I would start her off with all the things she had eaten at my house that she liked, and she could take it from there. She loved it—and soon I was making ones for all my friends. Not only did they enjoy their books, but I get a kick every time I go to one of their houses and see my cookbook on the counter, covered with cooking stains! There's no higher compliment to a chef than imitation.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-9"
    }
  }), _vm._v("Into the Pool")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("Meeting Debbie when I was thirty-three was like meeting a new playmate during second-grade recess and knowing we'd be “best friends.” Only it didn't happen on the playground. It happened in the predawn hours of a September morning after Debbie and I had swum the first 600 yards of a workout with our Masters swim team.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Two thousand yards and a dozen fifteen-second conversations later (the out-of-breath moments between swim sets), we had already shared some hearty laughs. During the kicking set near the end of the workout, we finally held a longer chat; the kick boards allowed us to keep our heads above water and swim side by side.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We learned that we were both one year postpartum, that her baby daughter and my twin girls were born only three days apart, and that her older daughter and my son were only a year apart. We were both still hauling around an extra fifteen pregnancy pounds, and we were stay-at-home moms who were held prisoner in our homes with young children during the day, and hence could only swim the morning practice. By the time we finished the workout and darted for our cars to get home before our husbands left for work, Debbie had convinced me to come swim with her every Monday, Wednesday, and Friday.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Soon thereafter we introduced our children to each other and set up frequent play dates. Within weeks we became each other's "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("confidante. By the end of the year, we were so much in synch that we could laugh our way through monthly bouts of PMS at the same time! In just over a year, we have swum in ten open-water races together, including a relay across Lake Tahoe and an insane adventure jumping off a ferry boat, with 400 other swimmers, into the 58-degree San Francisco Bay—without wet suits—to race to Alcatraz Island.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Out of the water, we've watched our little girls, now two years old, develop a sweet friendship, and our older children become playmates. We've watched one another shrink two sizes of jeans into the swimmers' bodies we flaunted as teenagers—or at least before motherhood. Our friendship was born in the water but thrives on land. Another added benefit? With our mutual motivation to keep each other in the pool, we'll both always fit into our size 6's!")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Cameron Sullivan")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("To like and dislike the same things, that is indeed true friendship.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLUST")])]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Natural Skin Cream")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("After a swim, skin needs some pampering. This cream lasts about one month at room temperature, and can be refrigerated for longer life. Beeswax is available at craft and health stores. If you want it to be a shade other than white, add a few drops of food coloring at the same time as the oils.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("8 teaspoons almond oil")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup grated beeswax")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("8 teaspoons distilled water")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("16 drops of your favorite essential oil")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Place the almond oil and beeswax in the top of a double boiler. Heat until wax melts, stirring frequently. Remove from heat, whisk in water and essential oil to emulsify the cream. Immediately turn into a sterilized container with a tight-fitting lid. Makes approximately ½ cup.")]), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("Finding Essential Oils and Other Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("Good sources for essential oils and other aromatherapy products are Bare Escentuals (800-227-3990), The Body Shop by Mail (800-541-2535), and Inner Balance catalog (800-345-3371).")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("There are also many great sites online, including "), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.butterburandsage.com",
      "target": "_blank"
    }
  }, [_vm._v("butterburandsage.com")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://www.buyaromatherapy.com",
      "target": "_blank"
    }
  }, [_vm._v("buyaromatherapy.com")])]), _vm._v(", and "), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.aromaproducts.com",
      "target": "_blank"
    }
  }, [_vm._v("aromaproducts.com")])]), _vm._v(".")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-10"
    }
  }), _vm._v("Childhood Memory")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("Sitting on the front steps of my best friend Pat's house those many years ago, the August sun resting on our tan shoulders, we decided that, Akron, Ohio, was the hottest place on earth. Desperate for a breeze, we brought our bicycles into the shade of the porch and flipped them upside down. Balancing the bikes on their handlebars, we operated the pedals by hand and spun the rear wheels as fast as possible. One thing led to another, and soon our makeshift fans became massive props pushing a frigate through high seas toward a beleaguered aircraft carrier (the neighbor's garage). Broom handles shoved through the rubberized bands of complexly folded chaise lounge chairs became antiaircraft guns, and Pat's little sister's tricycle became the helm.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The carrier was sinking fast, and the enemy was shooting at the sailors in the water. There was no way to reach them in time! Pat and I looked over our hopelessly underpowered engines and then at each other. There was only one solution. Acknowledging the inherent risks of using experimental technology in a battle situation, we formed a pact of secrecy, gave the official Navy handshake, and agreed that desperate times required desperate measures. Then we commandeered his big brother's new ten-speed.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("With one of us operating the gears and the other cranking "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("the pedals, we were able to achieve a cooling breeze and, with the addition of a baseball card held in place by a clothespin, nearly warp speed. Our frigate hydroplaned across the water to the rescue. I dove across the deck to the antiaircraft gun and began picking off enemy fighters. The choppy seas made sighting difficult, and the engine became unstable on its tiny handlebars. A fighter crashed into the water just a few feet from the bow, and the explosion sent me backwards into Pat, who in turn fell into the engine compartment.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("What followed was a sickening KaCHUNK! Pat and I looked at one another in horror; we had sustained heavy damage. The rear derailer of our ten-speed engine was jammed and the chain contorted into a pretzel. We were dead in the water. Enemy aircraft threatened to turn us into Swiss cheese, and Pat's brother was due home any minute! Pat ran below deck and returned with a screwdriver. I leaned on the tension pulley and slacked the chain, while Pat pried the links from between the axle and the rear sprocket. We spun the pedal, and the gears engaged just as Pat's brother appeared around the corner at the end of the street. We quickly put the ten-speed back where we found it, powered up the old engines, and proceeded to save the crew and dispatch the enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("If not for the exceptional skill and sacrifice of Chief Engineer Pat, and myself as Gunner's Mate, the world would surely have ended. Needless to say, the ice-cream man was very impressed "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("and listened with interest while mooring his supply vessel along our starboard bow.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Michael S. McKlusky")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are we not like the two volumes of one book?")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCELINE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESBORDES")]), _vm._v("-V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALMORE")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle1"
  }, [_vm._v("Friends")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-11"
    }
  }), _vm._v("Playing for Keeps")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("Sometimes when you meet someone, you just know right away that you are going to be friends. That's what happened with Carrie and me. I had taken a temporary job at the place where Carrie worked, and Carrie was the first person I met there. From the minute we met, we got along fine.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We soon discovered we both have the same abiding passion—we love to play Scrabble. We began to have all-day Scrabble marathons, usually at her house. Carrie's husband and children got used to the sight of the two of us sitting at her dining room table with the Scrabble board between us, concentrating on making words out of our letters. We did it so often that after a while her husband, Mike, would ask her, “Is Conover coming over to play Scrabble today?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("After a while Carrie and I got bored with regular Scrabble. So we began to experiment with longer words and bigger scores. Then we moved on to using names of associations and titles of songs. Ever supportive, Mike bought us two new Scrabble games, "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("because Carrie and I kept running out of letters. Now we go online and search for the longest names of whatever we can find. We each have our own board, and we keep all the letters face up between us, so we can find what we want more easily. We wrap our words around the board. So far, Carrie has had the longest phrase. It was a title to a magazine article, and it took up all her board and one line on mine. She made three hundred billion points. (We have our own scoring method, too.)")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Carrie and I so enjoy our way of playing that we've named it “C and C Scrabble.” Whoever we tell about how we play usually tells us we can't play that way, that we're cheating. But we just shrug and reply that it isn't cheating if we make up our own rules. Mike said it best when he said, “It makes you happy and that's all that matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("And that's true about our friendship, too. It makes us happy and that's all that matters.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Conover Swofford")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Friendship is a magic weaver.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROVERB")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-12"
    }
  }), _vm._v("Friendship Code")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("When I say that no one understands me as well as my best friend, I mean that literally. Over the years, we've developed a kind of secret code, a friendship shorthand. It started accidentally when she wanted to go to a certain coffeehouse, but couldn't remember the name. So she used the name of a similar-looking place in our former college town. Not only did I know the place she was referring to, but we've called it by its secret name for so long that I can no longer remember its correct name. Then I began having trouble with my boss, who actually forbid us to smile on the job. (The theory being that if we had time to smile, we were n't being efficient.) From that point on, he became “Mr. Nofun.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In our code, the past often mixes with the present as we refer to a colleague's clever actions as “pulling a Julie,” or describe a gaudy piece of jewelry as “Bonniefied.” We recall shared memories with just a few words: “chicken dinner in Mexico” makes us laugh, while mentioning “Fourth of July, 1986” casts a somber mood. Anyone eavesdropping on us would have difficulty deciphering our conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("That's why we only do this when we're alone. Talking this way in front of others misses the point. It's not to keep other people out; it's to keep us in.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Michelle Mach")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("'Tis the privilege of friendship to talk nonsense, and have her nonsense respected.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLES")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMB")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p27-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-13"
    }
  }), _vm._v("Automobile Adventure")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It was the seventies, and my friend and I were adventuring through the hear t of Germ any in a rented VW “Beetle” with standar d floor shift. Because I was used to an automatic transmission but could read German, and she could drive the car but not read the signs, we decided that she would be the driver and I the navigator. This worked well getting us out of Frankfurt and onto the Autobahn.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Traveling north on the Autobahn, we got sandwiched between two large trucks. The driver behind us waved, and, assuming he was being friendly, we waved back. My friend asked what the two large words were on the back of the truck in fro nt of us. I started going through my German dictionary, when the first truck turned onto a side road. We were too close to do anything but follow, the second truck close behind. “Verboten,” the dictionary informed me, meant “forbidden.” I rapidly turned pages until I "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("found the second word, “Dynamit” which, as you might be able to guess, means “dynamite.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The trucks were heading for a nearby quarry to blast rock. Finally the truck behind slowed enough for us to pull over to the side of the road. As he passed, we could see he was laughing uproariously. Sheepishly, we turned around and went back to the Autobahn. So much for instant language interpretation. I was admittedly rattled, but managed to get us to our destination an hour late. It was then I discovered I'd had the map upside down.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("My friend was still my friend—and still is—even though, as she puts it laughingly even now, “You will follow anyone, anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Marie Asner")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("We cherish our friends not for their ability to amuse us, but for ours to amuse them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VELYN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUGH")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-14"
    }
  }), _vm._v("Haul Out the Photo Albums")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("The older the better. Look at yourself and friends in those funny clothes and haircuts. Remember that shack the two of you used to live in? The trip to the Florida Keys you took in college, when you ate grapefruits off trees and slept on the beach? That old Mustang he used to drive? There's great pleasure in reminiscing, and photos are a great way to reconnect to the past. Take a trip through your friendship yesterdays—preferably together.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-15"
    }
  }), _vm._v("Reality Barometer")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("One of the true joys of friendship is having someone who promises to tell you when:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("Your hair looks horrible")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You look like a tramp in that dress")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Your butt looks huge in those pants")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("That color doesn't flatter")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You definitely need a face lift")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("You definitely need to stop having face lifts")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It's time to get out of those skin-tight leather pants and into something more age-appropriate before you end up looking like Cher.")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("On second thought, maybe lying's better.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("Honesty may be the best policy, but it's important to remember that apparently, by elimination, dishonesty is the second-best policy.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EORGE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLIN")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-16"
    }
  }), _vm._v("Walkabout")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("I've been trying to lose weight for years. I know it requires exercise, but I so hate to do it. I just could never stick to any regimen I started. That's why I was thrilled when a neighbor down the street asked me, a few years ago, if I wanted to walk each morning around the lake near our houses. I barely knew Sally, but I was desperate for a solution to my exercise dilemma. How could I not do it with her showing up at my door at seven a.m., dog leash in hand and monstrous poodle in tow?")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("That was three years ago, and now I wouldn't dream of missing a day. Snowstorms, rain, the heat of summer, we're out there, walking and talking. We gossip, laugh, chitchat about our dogs and those of the other walkers. We try to see how fast we can go. The time goes flying by.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Such a simple thing—a forty-five-minute walk with a friend. But the lift it gives me each morning sets the tone for my day.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Elizabeth Gonzales")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("But friendship is precious, not only in the shade, but in the sunshine of life; and thanks to a benevolent arrangement of things, the greater part of life is sunshine.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFFERSON")])]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Peppermint Foot Bath")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("After a brisk walk, surprise your friend with this relaxing foot bath.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("nonaluminum saucepan with lid")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("5 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("4 ounces dried peppermint leaves")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("8 ounces juniper berries (available at grocery stores)")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("24 drops sandalwood essential oil")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("12 drops cypress essential oil")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 coffee filter")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("funnel")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("pretty bottles or small jars with lids")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("labels and ribbon")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Place the water in the pan. Add the peppermint and juniper and heat on medium low to just below boiling point, stirring occasionally. Remove from heat, cover, and allow to cool. Add the essential oils and stir well.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Place the filter in the funnel and strain off the liquid into the bottles. To use, fill a large pan with hot water, stir in ¼ of a bottle, and soak feet for ten minutes.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-17"
    }
  }), _vm._v("The Poker Boys")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("On the first Friday of every month, five friends and I get together at one of our houses to play poker. But first we eat. The host prepares dinner, and because the chef job rotates to each of us only twice a year, we all try to outdo each other in culinary excess. When it's my turn, I pore over "), _c('i', [_vm._v("Saveur")]), _vm._v(" and raid my wife's cookbooks. I've made gumbo that requires stirring the roux for one hour until it turns exactly the right shade of brown, paella with six kinds of shellfish, Italian pork loin braised in milk—if it's full of saturated fat and carbohydrates, I've dished it up.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The first hour we eat and catch up on one another's lives—what's happening at work, who's bought a house, how the landscaping's going. Then the game begins—serious card playing that never seems to end until two a.m. no matter when we call last round. (We do take a dessert break at around eleven; wouldn't want to get hungry, after all.) The stakes are low—the most anyone has ever won in an evening is $40, but we hoot and holler nonetheless. We even have a trophy that rotates to the winner of the evening; at the end of the year, it gets engraved with the name of the guy who won the most that year. Sometimes someone can't make it, but that's rare, and if he hasn't given advance notice of at least a week, he gets fined $20.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("Nothing fancy, but I love it. It's the one opportunity in the month that I get to let off steam with the guys. We must all appreciate the chance—the six of us began playing almost twenty years ago, right out of college. We're still at it—through marriages, moves, babies, job changes. Depending on who's hosting, we may end up driving over an hour to get there. A few other men have come and gone, but the six of us play on.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p35-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Donald McIlraith")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The feeling of friendship is like that of being comfortably filled with roast beef.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMUEL")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHNSON")])]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Poker-Night Flank Steak")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("Here's a recipe that has been a huge favorite among the poker-playing friends. Try it the next time you have hearty meat-eating friends over for a barbeque.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup low-sodium soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 tablespoons grated fresh ginger")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 tablespoons freshly squeezed lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1½ pounds flank steak, trimmed")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Combine all ingredients except steak in a dish large enough to hold the steak. Place steak in dish, turning over several times to coat. Cover and refrigerate overnight, turning once or twice.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Prepare a grill to high heat. Remove steak from pan, reserving marinade. Grill the steak for 4 minutes per side until medium rare. Slice diagonally into ¼-inch thick slices and place on serving platter. Heat the marinade in the microwave until boiling, then serve on the side. Serves 4.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-18"
    }
  }), _vm._v("Listening to Leaves")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("At the end of the day, before the sun goes down, we go and listen to the leaves. Just Luka and me.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The wind pushes against us, ruffling our hair. Wind chimes swing wildly. We walk faster past garages, windows, and doorways. Leaves rattle sideways, tripping over our toes. A robin clings to the top of a swaying branch.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We stop under a tree. This is the perfect spot. I whisper to Luka, “If you are patient and very, very still, so still you are hardly breathing, you can hear the leaves sing.” We wait and we listen, trying hard not to breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In-between the bird song and gentle insect scuttles, the leaves take up a rustle and pass it on. One by one, cluster by cluster, branch by branch, until a soft song ripples through the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The wind swirls, whisking leaves to whirling delight. Leaf-song echoes the galloping wind, soaring into the sky. Rising, roaring a crescendo of harmony. Fading to a murmur, a gasp. Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("A few weary leaves twist, sigh, and spin to the ground. Luka and I catch them as they fall, russet, golden and crunchy. We chase them, fall over each other, laughing. Then we throw the leaves—up, up—until we are covered in autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("A scruffy cat slinks from under a bridge, stops, stares, then mooches on by. The light is fading. Time to go.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We jiggle as we walk. Back past the dented garage door. Past the soggy tennis ball abandoned on a sunnier day. Up the steps, "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("through the leaves, to our front door.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p38-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Luka and I stop to watch the sun go down. The wind has died. A faint aroma of wood smoke hangs in the air. I squeeze Luka's hand. He squeezes back. Tomorrow we will listen to the leaves again.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Just Luka and me.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Keely James")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Life is to be fortified by many friendships. To love and to be loved is the greatest happiness of existence.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YDNEY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MITH")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-19"
    }
  }), _vm._v("The Reunion")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("I sat motionless on the toilet in a stall in the ladies' room of the York County Elks Club. Dropping my head back, I dabbed at my throat with a fresh wad of toilet paper. I'd forgotten how hot it could get in June. “And you had to go and pick black lace,” I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I grabbed my thick, curly dark hair, bunching it on top of my head so that I could wipe the back of my neck. But I remembered the frizz problem, and let the hair fall back to my shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The neighboring toilet flushed, and I bent down to watch silver-clad feet walk out of the stall. I inspected my own shoes—black, strappy pumps, peau de soie, with the year's highest acceptable heel. I shifted on the toilet seat and waited. I breathed slowly through my mouth, eyes closed, wondering who was washing and drying her hands out there.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Finally heels clicked across the tiled floor. The bathroom door swung open, letting in a rush of music from the Elks Club meeting hall. Old Motown, I realized. Of course. The door closed, the music receded, and I was alone.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("No one had seen me yet. “You could still leave,” I told myself, opening the stall door and peeking out. I walked to the mirror. I ran my hands down the sides of the dress, feeling my ribcage. I pinched my waist, and feeling no extra skin, patted my hips. Nothing shook. “Tank,” I whispered, wincing a bit, remembering the hateful nickname I had been stuck with in high school. I "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("hoped twenty fewer pounds and twenty years were enough. I took one more look at my slimmed-down figure, checked my lipstick, and walked out of the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I stood in the doorway. The room was crowded, with people bunched into tight groups, talking and laughing loudly over the music. I recognized most of the faces, and smiled at each faintly, but couldn't make myself enter the room.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Tank!” I wasn't certain that I'd heard it at first, thinking, hoping it might be the music. But the voice came again, louder: “Tank!” I turned, and there she was. Kathy. The cheerleader, the beauty queen. All blue eyes, straight blond hair. Still. “Why, Darsey, you haven't changed a bit. Everyone's over there,” she said, pointing to the gaggle of her buddies. “You just HAVE to come over.” She smiled stiffly, all teeth, then turned around, leaving a wake of perfume. I watched her walk away.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Look at them. They're all hanging together. Just like the old days. And you know why Kathy's wearing that outfit don't you?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I wheeled around, coming almost nose to nose with Joy. Joy, glowing, in a black lace dress and silver high-heeled shoes, laughed with delight. I laughed too, and answered, “No. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Because she's hiding twenty pounds, that's why.” Joy held out her arms.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Joy!” I said, and hugged my old friend.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Darsey Hamilton")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("Laughter is inner jogging.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUSINS")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-20"
    }
  }), _vm._v("Adult Dress-Up")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("My friend Daphne and I love to play dress-up. We go shopping just for fun and spend a few hours trying on clothes. Ball gowns are particularly enjoyable. Just the other day we found the perfect thing for her to wear to the Academy Awards, if she were ever invited. She looked just like Marilyn Monroe at JFK's birthday party. Our favorite location for such frolics is Loehmann's because they have a group dressing room, so we have plenty of room to maneuver. We've played dress-up with fur coats, outrageous hats, death-defying high heels. All of the pleasure with none of the cost (well, sometimes we look so divine we can't help opening up the old wallet, and there "), _c('i', [_vm._v("was")]), _vm._v(" that time when Daphne left with ten smashing dresses …).")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("M. J. Ryan")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("Friendship is the wine of life.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DWARD")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNG")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-21"
    }
  }), _vm._v("Play Date")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("How about calling up a friend for a play date? Who says such events have to be only for kids? Adults need playtime too. How do you and your friend like to play? A day at the spa? A game of tennis followed by a good chat? Picnic in the park? Rather than feeling guilty that you don't spend enough time with friends, create an event.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("How about a picnic for a change of pace? Here are two easy-to-make dishes. Add some cookies and drinks, and you are all set.")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Make-Ahead Vegetable Salad")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("6 plum tomatoes, cut into eighths")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 green pepper, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 red onion, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 cucumber, peeled and thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¾ cup cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup water")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 tablespoons sugar")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1½ teaspoons celery salt")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1½ teaspoons mustard seed")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/frac18.jpg"
    }
  }), _vm._v(" to ¼ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/frac18.jpg"
    }
  }), _vm._v(" teaspoon pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Combine the tomatoes, green pepper, onion, and cucumber in a large bowl. Combine the remaining ingredients in a small saucepan. Bring to a boil, and boil for 1 minute. Pour over vegetables and toss to coat. Cover and refrigerate for 8 hours or overnight. Serve with a slotted spoon. Serves 8.")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Curried Pineapple Rice")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("½ cup finely chopped onion")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 jalapeño pepper, seeded and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 garlic cloves, minced")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1½ cups uncooked rice")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 tablespoon curry powder, or to taste")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("3 cups water or chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 tablespoon soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 20-ounce can unsweetened pineapple chunks, drained")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 pound fully cooked ham, cut into bite-sized pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("In a medium saucepan, heat oil and sauté onion until tender. Stir in jalapeño, garlic, rice, and curry powder. Sauté until rice begins to brown. Add water or broth and soy sauce. Cover and bring to a boil. Reduce heat and simmer for 20 minutes, until liquid is all gone and rice is tender. Stir in pineapple chunks and ham. Serve at room temperature. Serves 8.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-22"
    }
  }), _vm._v("In the Same Place")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("One of the pleasures of friendship is having someone who is in the same place in life at the same time—someone who can understand everything you are going through. My friend Jan and I share this special bond.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Jan and I have been on the same track from the very beginning—we have the same exact birthdate—month, day, and year. When we discovered this fact, we began to make it a tradition to celebrate our birthdays together. On our thirtieth—when we were both single, successful career girls—we took a whirlwind trip through Europe together. We lived every fantasy—theater in London, the Orient Express, and Italy, where we enjoyed fending off the amorous Italian men. The trip culminated in dancing all night in Monte Carlo on our actual birthday.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Over the years, Jan and I stayed on similar tracks, now toward a more domestic life. We met the men of our dreams (both engineers and entrepreneurs), got engaged, and were married within two months of each other. By the time our thirty-fifth birthdays rolled around, we were again sharing an experience—we were both new mothers. We had quit our jobs to stay home with our babies and were feeling quite different from the wild girls we had been just five short years before.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("To celebrate our birthdays, we decided to try to recapture some of our free spirit, and agreed to meet in San Francisco for dinner. As we waited for our table, we decided to go to the bar for "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("a drink. Glancing at the drink menu, we pondered aloud which of the French champagnes by the glass we would order to toast each other. A group of three men overheard us and insisted on buying us each a glass of the best chamspagne. We graciously accepted and engaged in a little harmless flirtation, figuring the men were just lonely, on business, and probably on expense accounts. Besides, we had our wedding rings quite visibly displayed as our shield from things getting too serious.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/p46-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We downed our champagne, and they offered to buy us another. We demurely refused. But they kept insisting that we have another drink. “Just give me one good reason why you won't let us buy you another glass of champagne,” one of them pushed.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Jan and I glanced at each other with a “what to do now?” kind of look.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Thinking quickly, she then blurted out, “If you really must know, it's because we're breastfeeding!”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("That quickly ended any romantic ideas on their part, and any illusions on our part that we were the wild girls of our pasts.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Kathy Cordova")])]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Spiced Vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("Put a little of that spice back in your friendship with this little present. Be sure to remove the garlic and ginger after the first day, to prevent botulism.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("1½ gallons cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("6 cloves garlic, halved")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup whole cloves")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup whole allspice")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("3 tablespoons celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup mustard seed")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("5 tablespoons black peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup sliced fresh ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Combine all ingredients in a large saucepan. Heat on medium low until just before boiling. Remove from heat and transfer to a nonmetallic container with a tight lid. Steep for 24 hours. Remove garlic and ginger. Let vinegar steep for a month. Strain and pour into glass bottles. Cover tightly. Makes 1½ gallons.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("What is a friend? A single soul in two bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RISTOTLE")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-23"
    }
  }), _vm._v("Blood Sisters")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("We peered through the broken glass in the garage window when we heard the screen door burst open and then slam against the side of the house. Granny was hollering out of the upstairs window, “Beth Ann, where are you going? Breakfast is almost ready. Beth Ann, you get in here this instant!”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Beth Ann's long, auburn pigtails flapped wildly against her shoulders as she ran toward us, extending her arm to reveal a tightly clenched fist. In an excited whisper she said, “I've got it! I've got it! But we have to be quick about it. If I don't get back upstairs soon, Granny is going to get the belt.” She opened her palm to reveal a long hatpin with a lar ge pearl attached to one end. “It's her favorite one. She uses it on Sundays to keep her hat on in church.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Cathy and I stared at the pin's pointy end. “I don't know,” Cathy said, slowly shaking the blonde curls that surrounded her face like the petals of a sunflower. “It looks awfully big.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Beth Ann laughed. “What does that matter? We're only using the tip, silly.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("I picked up the pin and gently ran my finger across the pointed end. “This will do the trick all right. Who wants to go first?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Cathy took a step backward. “I don't know. Are you sure this is necessary?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Beth Ann grabbed the pin. “Of course it is. We have to do this if we want to be blood brothers … or blood sisters or whatever you call it. It's part of the oath. Now we'd better hurry up or I'll get in trouble. Watch, I'll go first.” With that she jabbed the tip of the pin into her thumb and then squeezed until a small red droplet appeared.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Cathy nervously bit her lip. “Did it hurt? Be honest or I'm not doing it.” Beth Ann passed me the pin and said, “It only pinched for a minute. Now don't be a baby. Watch how Pam does it.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("With one sharp sting, the hatpin pierced my flesh. I looked into Cathy's doubtful blue eyes and said, “See, that's all there is to it. Now hurry up before the blood starts to dry.” Her hand trembled as she took the pin and tried three times. “I can't do it, you guys. It's going to hurt, I just know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Granny's head popped out of the upstairs window. “Beth Ann Smith, you get into this house right now. Your food is getting cold. What are you up to anyways?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("“Nothing Granny. I'm just talking to the girls. I'll be right up. I promise,” she replied. Quickly, Beth Ann took the pin from Cathy and I grabbed Cathy's hand. Before she could pull away the pin was plunged into the tip of her thumb. “OUCH! I knew "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("it would hurt. That's no fair, you guys.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I released her hand and said, “Don't be a whiner. Now squeeze out some blood.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We stood there silently while a delivery truck rattled and rumbled down the street, with the smell of bacon wafting through the broken pane that splashed sunlight across the spiderweb, making it sparkle like an ornament made of diamonds. Beth Ann took a deep breath and said, “Ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Cathy and I inched closer to her and replied in unison, “Ready.” With that, we pressed our blood-covered thumbs together and swore an oath of friendship that was even stronger than our devotion to Donny Osmond.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Pamela A. Rogers")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("One's friends are that part of the human race with which one can be human.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EORGE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANTAYANA")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-24"
    }
  }), _vm._v("Ornamental Pleasures")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("It started fifteen years ago. Two weeks before Christmas, Kathleen gathered ten of her women friends together for a ladies' luncheon and tree-ornament swap. None of us knew each other, but we were all linked by our friendship with Kathleen. She's the kind of person who makes fun wherever she goes, and that lunch was no exception. We laughed, we traded stories of our lives. By the end, we vowed to do it again the following year.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("And so it became a tradition. We don't see one another much in-between, but we look forward eagerly to our appointed lunch, and choose our ornaments with care. At some point along the way, Kathleen moved to Hawaii, but she always comes back to play hostess. It just wouldn't be Christmastime without it!")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("S.S.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("A friend is a present you give yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUIS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEVENSON")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-25"
    }
  }), _vm._v("Keepsake Ornaments")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("Want to give a friend a one-of-a-kind Christmas ornament? Consider these two easy ideas. You won't believe how great they look.")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Cinnamon-Stick Bundle")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("whole cinnamon sticks")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("hot-glue gun")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("plastic or silk holly sprig")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("ribbon or raffia")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Make a bundle of cinnamon sticks by gluing 5 or 6 together with the glue gun, one at a time, at their centers. Tie ribbon or raffia around center of bundle to conceal any hot-glue drops. Glue the holly sprig in the center of the ribbon. Tie a loop of ribbon or raffia at the center of ornament for a hanger. Makes 1.")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Miniature Vine Wreaths")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("tiny vine wreaths (available at craft stores)")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("dried flowers and herbs, such as lavender, artemisia, globe amaranth, strawflowers, pearly everlasting")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("hot-glue gun")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("thin ribbon for hanger")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Hot-glue flowers in a pleasing arrangement. Tie on ribbon hanger at top of wreath. You may want to hot-glue a flower on the ribbon where it meets the wreath. Makes 1.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-26"
    }
  }), _vm._v("Mustang Tuesdays")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("At four o'clock every Tuesday afternoon, John and I would drive from the Queens campus of St. John's University to the Arthur Kill Correctional Facility, where we taught inmates in the university's external degree pr ogram. John had been teaching Public Speaking at St. John's for twenty years before I returned to my alma mater as Assistant Dean. We quickly became a team—arguing for academic integrity at the Faculty Council, organizing poetry readings, spending much free time 'round the Speech Department's coffeepot fomenting revolution against the university's medieval president, or inviting colleagues to deliver the lecture they would like to be remembered for.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("John's just-off-campus apartment was a clubhouse for students, alumni, faculty, and even a few eccentric administrators like me. The pad's unkempt nature fit perfectly with its drop-in informality. John was obsessive about keeping a clean toilet, but his dedication to housekeeping did not extend beyond that tiled space. If I or any of John's other pals complained about the dishes in the sink, or the cobwebs and dust, or the holes in the screen door, we'd be directed to the relevant chemicals and housewares. John's apartment … was ours. How else would John have found time to teach his classes, write his articles, prepare his own distinguished lectures, and moderate the discussions that ran through the nights until the wine bottles lay uncorked and dry?")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("When I established the prison program, I recruited John to teach, and scheduled his class on the same evening as my own Creative Writing class. After each Tuesday's Curriculum Committee meeting, we'd leave campus in my Mustang and follow the Belt Parkway along New York Bay to the Verrazano Narrows Bridge, clear to the west end of Staten Island.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("And, in contrast to all the talk at meetings and at John's house, we'd say not a word to each other. We didn't feel compelled to entertain each other or keep conversation going. Silence was not the rule, but our habit on these Tuesday trips—a pleasure that could never be replaced by a drive by oneself. We simply enjoyed each other's presence.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("James Penha")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Some of the most rewarding and beautiful moments of a friendship happen in the unforeseen open spaces between planned activities. It is important that you allow these spaces to exist.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTINE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEFELDT")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-27"
    }
  }), _vm._v("Some Things Never Change")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _vm._v("Deb and I met in a college poetry class, and we've been friends ever since. In the years that have followed, she's been my study partner, my roommate, my guinea pig for new recipes, my shoulder to cry on, my traveling companion, and my maid of honor. Though we now live hundreds of miles apart, we're still the best of friends. I've got the phone bills to prove it. And when we do get to spend time together, it's as though we're still two college kids, sharing an apartment on campus.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Over the holidays, I spent a week back home. Deb's birthday was that week, so the two of us planned to go out for dinner to celebrate. We decided to go to an Indian restaurant—because we still haven't been able to find anyone else who shares our love of Indian food.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("As we ate, we chatted as if we'd been apart for three days instead of three months. We talked about work and the books we were reading and the movies we wanted to see. We laughed about the good old days and predicted our futures as we ate from each other's plates.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("After dinner, we drove back to Deb's apartment for dessert—to recreate her twenty-first birthday. That year, her birthday was the day before a big final exam, so going out to celebrate in style wasn't really a wise choice. Instead, we took a study break in our apartment. Now, several years later, we celebrated the same way—"), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _vm._v("by making a big batch of chocolate frosting and eating it straight out of the pan. We passed the pan back and forth, watching reruns of "), _c('i', [_vm._v("The Muppet Show")]), _vm._v(" just as we had done years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("I'm confident that, for Deb and me, some things will never change. We may move to different states—or even different countries. We may change jobs and start families. But no matter where we live or what happens in our lives, we'll also be there for each other. Years from now, we'll still be able to share our stories and laugh together. We'll still spend hours discussing our favorite books. We'll still love John Cusack movies and "), _c('i', [_vm._v("The Muppet Show")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("And we'll still celebrate her birthday by eating chocolate frosting right out of the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Kristin Dreyer Kramer")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Wherever you are it is your friends that make your world.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")])]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Fabulous Fudge")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _vm._v("Sometimes all the two of you need is a little chocolate. This is my grandmother's recipe for no-fail fudge. It's a great friendship sweetener.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("1 7-ounce jar Marshmallow Fluff")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/frac23.jpg"
    }
  }), _vm._v(" cup evaporated milk")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1"), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/frac13.jpg"
    }
  }), _vm._v(" cups sugar")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 12-ounce package semisweet chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 teaspoon vanilla")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Combine all ingredients except chocolate and vanilla in a medium saucepan. Bring to a boil. Boil, stirring constantly, for 5 minutes. Remove from heat, add chocolate chips, stirring, until all chocolate has melted. Add vanilla and stir. Turn into 8-inch-square buttered pan. Let cool until hardened. Cut into squares. Makes 2½ pounds.")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-28"
    }
  }), _vm._v("The Laughing Fit")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v("The two of us were at a meditation retreat for a week. A silent retreat. Luckily, we knew ourselves well enough to know that we couldn't resist talking. So we had arranged to share a room, and we perfected the art of whispering in our beds each evening like a couple of schoolgirls. Toward the end of the week, as we lay there, one of us said something funny to the other. I don't remember who or what. And we started to laugh. And laugh. Quickly we clutched our pillows to our faces, desperately trying not to be heard. Tears rolled down our cheeks as we tried to control ourselves. When one of us began to gain some modicum of composure, she'd look at the other and burst out again. It went on and on—ten minutes at least. My sides ached from laughing and the effort to restrain myself. Part of me was more joyful than I have been in my whole life. The other part was worrying about getting in trouble for breaking silence. When we finally calmed down (the only thing that worked was ignoring one another), I realized I hadn't laughed that hard in forty years. What fun!")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("M. J. Ryan")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _vm._v("The average person living to age 70 has 613,000 hours of life. This is too long a period not to have fun.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NONYMOUS")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-29"
    }
  }), _vm._v("Divine Rights")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The year was 1964 and I was a teenager. The Pope was not only coming to New York but was scheduled to pass under the windows of our classrooms on Madison Avenue in Manhattan. We were given strict instructions to return to class promptly after lunch, and not to join the swelling crowds of people. More precisely, we were not permitted to be late or cut class to see the motorcade.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Alas, the draw was too great. My friend and I opted to risk the consequences in order to see the Pope. Satisfied but afraid, we returned to class thirty-five minutes late, to be met by the ominous glare of our teacher. Her arm extended, and finger pointing to the door, she commanded, “To the principal's office!”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The principal, Mrs. Sadie Brown, a wizened old woman in her nineties, listened quietly as we told of our indiscretion. She said nothing. Then, reaching to her desk, she scribbled something on a piece of paper. She folded the paper, speaking only to instruct "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _vm._v("us to hand it to our teacher. Safely out of view, my friend and I opened the paper. It read, simply: “Papal dispensation.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Pat Gallant")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you obey all of the rules, you miss all of the fun.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHERINE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPBURN")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-30"
    }
  }), _vm._v("A Cup of Tea")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _vm._v("It was a simple moment—one I anticipated after a taxing morning. Promptly at two o'clock I heard the car door slam and conjured up the smell of scones and tea biscuits even before the back door opened. Lisa was bringing afternoon tea!")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("She greeted me with a booming laugh and a brimming basket. Starched linen napkins, an English teapot and cozy, Battenberg lace runner, and Delft cups met my gaze. My nose caught the whiff of freshly baked goodies hidden from sight; what tea would accompany them today? Earl Grey or English breakfast tea? Maybe I would splurge with something bolder, like an Indian or Kenyan tea.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Enjoying the ritual we loved so well, Lisa and I traded initial pleasantries as we laid the table. The lace runner alighted on the table like a butterfly seeking rest. I placed the teapot and cups in their accustomed positions, while Lisa apportioned the delicacies on china plates. Within minutes the interchange drifted towards the second level of conversation—personal concerns and reports of family matters.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Sipping and tasting, we plunged into the sea of conversation. The ebb and flow eventually deposited us on the sand of scone crumbs, in the shadow of a tea cozy. Reluctantly we folded napkins and repacked the familiar basket as the clock chimed three times. Another tea time was closing, and yet this one was unlike all the others: Lisa was moving to Africa where her family would "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _vm._v("work in an orphanage.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("We hesitated to voice our thoughts, simultaneously clutching the basket as each one reached for an errant corner of the lace runner. Wordlessly, our eyes and hearts whispered, “Until next time.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Unhurriedly, she gathered the items and turned to leave. I watched as the door opened and closed. Glancing back to the table, I noticed that Lisa had forgotten one of her cups. I started to knock on the kitchen window to get her attention, but immediately realized the cup was actually not forgotten. Instead, I held a keepsake of a simple pleasure of friendship—a shared moment.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Diane H. Pitts")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Find yourself a cup of tea; the teapot is behind you. Now tell me about hundreds of things.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKI")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "c1-31"
    }
  }), _vm._v("An Afternoon Tea Party")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Here are some sandwiches served at a traditional tea. Don't forget to cut the crust off the bread.")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Watercress Sandwiches")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _vm._v("1 bunch watercress")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("8 tablespoons butter")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("4 teaspoons lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("8 slices white bread")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("salt to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Wash watercress and trim leaves off stems. Set aside. Mix the butter and lemon juice in a food processor or blender. Spread butter lightly on bread. Arrange watercress leaves on butter. Salt lightly. Top with bread slice. Cut into 4 pieces. Makes 16 tea-sized sandwiches.")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Cucumber Sandwiches")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("1 large cucumber")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("salt to taste")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("mayonnaise to taste")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("butter to taste")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("4 slices bread")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Remove seeds and slice cucumber as thinly as possible. Place in pan and sprinkle with salt. Cover with paper towels to absorb moisture and let sit for 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Spread mayonnaise and butter on bread. Arrange cucumbers attractively on top. Cut into quarters. Makes 16 open-faced tea-sized sandwiches.")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Strawberry Sandwiches")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _vm._v("2 tablespoons butter")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("½ cup confectioners' sugar")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 teaspoons lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("4 large strawberries")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("8 slices bread")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Combine all ingredients except bread in food processor. Allow to harden in refrigerator for 3 hours. Spread on bread and cut each slice into 4. Makes 24 open-faced tea-sized sandwiches.")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle2"
  }, [_vm._v("Poppy Seed Scones")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Here's a simple recipe for the next tea party you throw. Scones are also great at breakfast time. If you want to be truly British, try serving them with lemon curd.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("¼ cup sugar")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 cups all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 tablespoon poppy seeds")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1 tablespoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/frac13.jpg"
    }
  }), _vm._v(" cup butter")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2 tablespoons lemon juice in ¾ cup milk")])]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Preheat oven to 425° F. In a large bowl, combine sugar, flour, poppy seeds, baking powder, and salt. Cut in butter until "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _vm._v("mixture is crumbly. Add milk mixture until blended. Turn onto a floured board and knead six times. Shape into a ball, then form into an 8-inch circle. Cut into 8 pieces, as if cutting a pizza. Place on a greased cookie sheet and bake for 12–15 minutes, or until scones are lightly browned. Makes 8 scones.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("There are few hours in life more agreeable than the hour dedicated to the ceremony known as afternoon tea.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENRY")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")])]), _vm._v(" "), _c('div', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("The Perfect Cup of Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _vm._v("There are over 2,000 teas in the world, but they all come from one plant—the tropical Camellia Sinensis, a relative of the common garden camellia. The variations in taste are created in the method of processing, which results in four main groups—black, oolong, green, and white. Black tea accounts for over 90 percent of the tea consumption in the Western world. And when it comes to black tea, no one does it better than the British. They raised tea drinking to the status of a meal—a late afternoon affair complete with small sandwiches, cakes, and other treats to tide you over until dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("If you want to host a tea for friends, make sure that the tea itself is brewed properly. No steeping in your cup allowed—you "), _c('i', [_vm._v("must")]), _vm._v(" have a teapot and, preferably, a tea cozy to keep the pot warm.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Directions: Fill kettle with cold water and bring to a hard boil. Scald teapot with boiling water. Place 1 teabag per cup in the teapot, or, for true authenticity, 1 rounded teaspoon of loose tea per cup into an infuser in the pot. Let steep for 3 minutes. Remove infuser and serve. Ah!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9aa53626","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_chapter01.vue
// module id = 78
// module chunks = 0